export const CURRENT_LOCALES = navigator.languages.slice(0);
export const defaultToLocaleStringOptions = {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
};
class LocalizedNumber {
    separators;
    constructor(locale = CURRENT_LOCALES[0]) {
        const parts = new Intl.NumberFormat(locale).formatToParts(12345.6);
        const numerals = [...new Intl.NumberFormat(locale, { useGrouping: false }).format(9876543210)].reverse();
        const groupValue = parts.find((d) => d.type === "group")?.value;
        const decimalValue = parts.find((d) => d.type === "decimal")?.value;
        const numeralsValue = numerals.join("");
        this.separators = {
            group: groupValue,
            decimal: decimalValue,
            numeral: numeralsValue,
        };
    }
    get numberSeparators() {
        return this.separators;
    }
}
export const localizedNumber = new LocalizedNumber();
